export default __webpack_public_path__ + "static/photon_bulb-93c718bdfa29a40c151fcd4da25dc71d.svg";